import React from "react";
type CtaButtonProps = {
  href: string | null;
  children: React.ReactNode;
  fullWidth?: boolean;
};
const base = "inline-flex items-center justify-center rounded-2xl bg-sand px-7 py-4 text-center font-display text-[22px] font-bold uppercase leading-none tracking-wide text-forest-deep shadow-[0_6px_0_#9C7C4A] transition-[background-color,transform,box-shadow] duration-150 ease-out md:px-9 md:py-5 md:text-[27px] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-forest";
export function CtaButton({
  href,
  children,
  fullWidth = false
}: CtaButtonProps) {
  const width = fullWidth ? "w-full" : "";
  if (!href) {
    return <button type="button" disabled aria-disabled="true" className={`${base} ${width} cursor-not-allowed opacity-80`} data-id="element-228" data-mp="1h61oyyg391i0">
        {children}
      </button>;
  }
  return <a href={href} className={`${base} ${width} hover:bg-sand-hover active:translate-y-[3px] active:shadow-[0_3px_0_#9C7C4A]`} data-id="element-229" data-mp="138wcaflvd4ds">
      {children}
    </a>;
}